var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHabitIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 88.06 88.06",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,12a3,3,0,0,0-3,3V41H15a3,3,0,1,0,0,6H44a3,3,0,0,0,3-3V15A3,3,0,0,0,44,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,0a44,44,0,1,0,44,44A44.08,44.08,0,0,0,44,0Zm0,82.06a38,38,0,1,1,38-38A38.07,38.07,0,0,1,44,82.06Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHabitIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/habit_icon.e8ed254c.svg";
export { ForwardRef as ReactComponent };